/**
 * Standard column width constants for all tables.
 *
 * @example
 * ```typescript
 * import { COLUMN_WIDTH } from '@/components/atomic/table/constants'
 *
 * TEXT_COLUMN({
 *   headerName: 'Issuer',
 *   field: 'issuer',
 *   minWidth: COLUMN_WIDTH.W_200,
 * })
 * ```
 *
 */
export const COLUMN_WIDTH = {
  /** 60px - Icons, checkboxes, boolean flags */
  W_60: 60,
  /** 80px - Icons, checkboxes, boolean flags */
  W_80: 80,
  /** 100px - Compact fields (ratings, ticker, YTM, YTW) */
  W_100: 100,
  /** 120px - Standard numeric/date fields (most common) */
  W_120: 120,
  /** 140px - Status badges, short labels */
  W_140: 140,
  /** 160px - Grouping columns (advisors, accounts) */
  W_160: 160,
  /** 180px - Expandable text columns */
  W_180: 180,
  /** 200px - Text fields (issuer, sector, money manager) */
  W_200: 200,
  /** 250px - Progress bars, wide components */
  W_250: 250,
  /** 300px - Very long text fields (purpose) */
  W_300: 300,
} as const
